import { products } from "../../data/products";
import Button from "../ui/Button";
import Container from "../ui/Container";
import ProductMark from "../ui/ProductMark";
import StatusBadge from "../ui/StatusBadge";

function ProductsPage() {
  return (
    <main>
      <section className="border-b border-border/70 py-16 sm:py-20">
        <Container>
          <p className="mb-5 text-xs font-medium uppercase tracking-[0.18em] text-accent">
            Technie ecosystem
          </p>
          <h1 className="max-w-3xl text-4xl font-semibold tracking-normal text-primary sm:text-5xl">
            Products built under one studio.
          </h1>
          <p className="mt-5 max-w-2xl text-base leading-7 text-secondary">
            Current releases and planned product directions across student platforms, AI tools, mobile apps,
            developer utilities, and SaaS products.
          </p>
        </Container>
      </section>

      <section className="py-12 sm:py-16">
        <Container>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {products.map((product) => {
              const hasLiveLink = product.link && product.link !== "#";

              return (
                <article
                  key={product.id}
                  className="flex min-h-[250px] flex-col rounded-2xl border border-border/80 bg-surface/20 p-5 transition-all duration-200 ease-in-out hover:border-accent/35 hover:bg-surface/30"
                >
                  <div className="flex items-start justify-between gap-4">
                    <ProductMark label={product.logo} />
                    <StatusBadge status={product.status} />
                  </div>
                  <div className="mt-5">
                    <p className="text-xs font-medium uppercase tracking-[0.14em] text-muted">
                      {product.category}
                    </p>
                    <h2 className="mt-2 text-lg font-semibold text-primary">{product.name}</h2>
                    <p className="mt-3 text-sm leading-6 text-secondary">{product.description}</p>
                  </div>
                  <div className="mt-auto pt-6">
                    {hasLiveLink ? (
                      <Button
                        as="a"
                        href={product.link}
                        target="_blank"
                        rel="noreferrer"
                        variant="secondary"
                        className="w-full"
                      >
                        Visit Product
                      </Button>
                    ) : (
                      <span className="inline-flex min-h-10 w-full items-center justify-center rounded-xl border border-border/70 px-4 text-sm font-medium text-muted">
                        In Development
                      </span>
                    )}
                  </div>
                </article>
              );
            })}
          </div>
        </Container>
      </section>
    </main>
  );
}

export default ProductsPage;
